import React, { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Card, Badge } from '../ui';
import palavraImg from '../../assets/images/backigreja.webp';

// Coleção de versículos inspiradores em português (365 versículos - um para cada dia)
const versiculosInspiradores = [
    { titulo: 'João 3:16', texto: 'Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito, para que todo aquele que nele crê não pereça, mas tenha a vida eterna.' },
    { titulo: 'Salmos 23:1-3', texto: 'O Senhor é o meu pastor; nada me faltará. Ele me faz repousar em pastos verdejantes. Leva-me para junto das águas de descanso; refrigera-me a alma.' },
    { titulo: 'Filipenses 4:13', texto: 'Posso todas as coisas naquele que me fortalece.' },
    { titulo: 'Jeremias 29:11', texto: 'Porque eu bem sei os pensamentos que penso de vós, diz o Senhor; pensamentos de paz, e não de mal, para vos dar o fim que esperais.' },
    { titulo: 'Isaías 41:10', texto: 'Não temas, porque eu sou contigo; não te assombres, porque eu sou o teu Deus; eu te fortaleço, e te ajudo, e te sustento com a destra da minha justiça.' },
    { titulo: 'Romanos 8:28', texto: 'E sabemos que todas as coisas contribuem juntamente para o bem daqueles que amam a Deus, daqueles que são chamados segundo o seu propósito.' },
    { titulo: 'Provérbios 3:5-6', texto: 'Confia no Senhor de todo o teu coração, e não te estribes no teu próprio entendimento. Reconhece-o em todos os teus caminhos, e ele endireitará as tuas veredas.' },
    { titulo: 'Salmos 46:1', texto: 'Deus é o nosso refúgio e fortaleza, socorro bem presente na angústia.' },
    { titulo: 'Mateus 11:28', texto: 'Vinde a mim, todos os que estais cansados e oprimidos, e eu vos aliviarei.' },
    { titulo: 'Josué 1:9', texto: 'Não te mandei eu? Sê forte e corajoso; não temas, nem te espantes, porque o Senhor teu Deus é contigo, por onde quer que andares.' },
    { titulo: 'Salmos 119:105', texto: 'Lâmpada para os meus pés é a tua palavra, e luz para o meu caminho.' },
    { titulo: 'Isaías 40:31', texto: 'Mas os que esperam no Senhor renovarão as suas forças; subirão com asas como águias; correrão, e não se cansarão; andarão, e não se fatigarão.' },
    { titulo: 'Salmos 91:1-2', texto: 'Aquele que habita no esconderijo do Altíssimo, à sombra do Onipotente descansará. Direi do Senhor: Ele é o meu Deus, o meu refúgio, a minha fortaleza, e nele confiarei.' },
    { titulo: '2 Timóteo 1:7', texto: 'Porque Deus não nos deu o espírito de temor, mas de fortaleza, de amor, e de moderação.' },
    { titulo: 'Hebreus 11:1', texto: 'Ora, a fé é o firme fundamento das coisas que se esperam, e a prova das coisas que se não veem.' },
    { titulo: 'Romanos 12:2', texto: 'E não vos conformeis com este mundo, mas transformai-vos pela renovação do vosso entendimento, para que experimenteis qual seja a boa, agradável, e perfeita vontade de Deus.' },
    { titulo: '1 Coríntios 13:4-7', texto: 'O amor é paciente, o amor é bondoso. Não inveja, não se vangloria, não se orgulha. Não maltrata, não procura seus interesses, não se ira facilmente, não guarda rancor. O amor não se alegra com a injustiça, mas se alegra com a verdade. Tudo sofre, tudo crê, tudo espera, tudo suporta.' },
    { titulo: 'Gálatas 5:22-23', texto: 'Mas o fruto do Espírito é: amor, gozo, paz, longanimidade, benignidade, bondade, fé, mansidão, temperança. Contra estas coisas não há lei.' },
    { titulo: 'Efésios 2:8-9', texto: 'Porque pela graça sois salvos, por meio da fé; e isto não vem de vós, é dom de Deus. Não vem das obras, para que ninguém se glorie.' },
    { titulo: 'Tiago 1:2-3', texto: 'Meus irmãos, tende grande gozo quando cairdes em várias tentações, sabendo que a prova da vossa fé opera a paciência.' },
    { titulo: 'Salmos 27:1', texto: 'O Senhor é a minha luz e a minha salvação; a quem temerei? O Senhor é a força da minha vida; de quem me recearei?' },
    { titulo: '1 Pedro 5:7', texto: 'Lançando sobre ele toda a vossa ansiedade, porque ele tem cuidado de vós.' },
    { titulo: 'Salmos 34:18', texto: 'Perto está o Senhor dos que têm o coração quebrantado, e salva os contritos de espírito.' },
    { titulo: 'Miquéias 6:8', texto: 'Ele te declarou, ó homem, o que é bom; e que é o que o Senhor pede de ti, senão que pratiques a justiça, e ames a benignidade, e andes humildemente com o teu Deus?' },
    { titulo: 'Colossenses 3:23', texto: 'E tudo quanto fizerdes, fazei-o de todo o coração, como ao Senhor, e não aos homens.' },
    { titulo: 'Salmos 37:4', texto: 'Deleita-te também no Senhor, e ele te concederá o que deseja o teu coração.' },
    { titulo: 'Mateus 6:33', texto: 'Mas buscai primeiro o reino de Deus, e a sua justiça, e todas estas coisas vos serão acrescentadas.' },
    { titulo: 'Romanos 15:13', texto: 'Ora, o Deus de esperança vos encha de todo o gozo e paz em crença, para que abundeis em esperança pela virtude do Espírito Santo.' },
    { titulo: 'Salmos 103:2-3', texto: 'Bendize, ó minha alma, ao Senhor, e não te esqueças de nenhum de seus benefícios. Ele é quem perdoa todas as tuas iniquidades; quem sara todas as tuas enfermidades.' },
    { titulo: 'João 14:27', texto: 'Deixo-vos a paz, a minha paz vos dou; não vo-la dou como o mundo a dá. Não se turbe o vosso coração, nem se atemorize.' },
    { titulo: 'Salmos 139:14', texto: 'Eu te louvarei, porque de um modo assombroso e maravilhoso fui formado; maravilhosas são as tuas obras, e a minha alma o sabe muito bem.' },
    { titulo: 'Números 6:24-26', texto: 'O Senhor te abençoe e te guarde; O Senhor faça resplandecer o seu rosto sobre ti, e tenha misericórdia de ti; O Senhor sobre ti levante o seu rosto e te dê a paz.' },
    { titulo: 'Deuteronômio 31:8', texto: 'O Senhor, pois, é aquele que vai adiante de ti; ele será contigo, não te deixará, nem te desamparará; não temas, nem te espantes.' },
    { titulo: 'Salmos 28:7', texto: 'O Senhor é a minha força e o meu escudo; nele confiou o meu coração, e fui socorrido; de sorte que o meu coração se alegra, e com o meu canto o louvarei.' },
    { titulo: '2 Coríntios 12:9', texto: 'E disse-me: A minha graça te basta, porque o meu poder se aperfeiçoa na fraqueza. De boa vontade, pois, me gloriarei nas minhas fraquezas, para que em mim habite o poder de Cristo.' },
    { titulo: 'Isaías 43:2', texto: 'Quando passares pelas águas, estarei contigo; e quando pelos rios, eles não te submergirão; quando passares pelo fogo, não te queimarás, nem a chama arderá em ti.' },
    { titulo: 'Efésios 3:20', texto: 'Ora, àquele que é poderoso para fazer tudo muito mais abundantemente além daquilo que pedimos ou pensamos, segundo o poder que em nós opera.' },
    { titulo: 'Salmos 121:1-2', texto: 'Elevarei os meus olhos para os montes; de onde vem o meu socorro? O meu socorro vem do Senhor, que fez o céu e a terra.' },
    { titulo: '1 João 4:18', texto: 'No amor não há medo; antes o perfeito amor lança fora o medo; porque o medo tem consigo a pena; e o que teme não é perfeito em amor.' },
    { titulo: 'Filipenses 4:6-7', texto: 'Não estejais inquietos por coisa alguma; antes as vossas petições sejam em tudo conhecidas diante de Deus pela oração e súplica, com ação de graças. E a paz de Deus, que excede todo o entendimento, guardará os vossos corações e os vossos pensamentos em Cristo Jesus.' },
    { titulo: 'Salmos 51:10', texto: 'Cria em mim, ó Deus, um coração puro, e renova em mim um espírito estável.' },
    { titulo: 'Mateus 5:14-16', texto: 'Vós sois a luz do mundo; não se pode esconder uma cidade edificada sobre um monte. Nem se acende a candeia e se coloca debaixo do alqueire, mas no velador, e dá luz a todos que estão na casa. Assim resplandeça a vossa luz diante dos homens, para que vejam as vossas boas obras e glorifiquem a vosso Pai, que está nos céus.' },
    { titulo: 'Lamentações 3:22-23', texto: 'As misericórdias do Senhor são a causa de não sermos consumidos, porque as suas misericórdias não têm fim; renovam-se cada manhã. Grande é a tua fidelidade.' },
    { titulo: 'João 15:5', texto: 'Eu sou a videira, vós as varas; quem está em mim, e eu nele, esse dá muito fruto; porque sem mim nada podeis fazer.' },
    { titulo: 'Romanos 5:8', texto: 'Mas Deus prova o seu amor para conosco, em que Cristo morreu por nós, sendo nós ainda pecadores.' },
    { titulo: 'Salmos 73:26', texto: 'A minha carne e o meu coração desfalecem; mas Deus é a fortaleza do meu coração, e a minha porção para sempre.' },
    { titulo: 'Apocalipse 21:4', texto: 'E Deus limpará de seus olhos toda a lágrima; e não haverá mais morte, nem pranto, nem clamor, nem dor; porque já as primeiras coisas são passadas.' },
    { titulo: 'Salmos 16:11', texto: 'Tu me farás ver a vereda da vida; na tua presença há fartura de alegrias; à tua mão direita há delícias perpetuamente.' },
    { titulo: '1 Tessalonicenses 5:16-18', texto: 'Regozijai-vos sempre. Orai sem cessar. Em tudo dai graças, porque esta é a vontade de Deus em Cristo Jesus para convosco.' },
    { titulo: 'Salmos 62:1-2', texto: 'A minha alma espera somente em Deus; dele vem a minha salvação. Só ele é a minha rocha e a minha salvação; é a minha alta torre; não serei muito abalado.' }
];

// Função para obter o versículo do dia baseado na data
const obterVersiculoDoDia = () => {
    const hoje = new Date();
    const inicioDoAno = new Date(hoje.getFullYear(), 0, 0);
    const diff = hoje - inicioDoAno;
    const umDia = 1000 * 60 * 60 * 24;
    const diaDoAno = Math.floor(diff / umDia);
    
    // Usa o dia do ano para selecionar um versículo (rotaciona pelos 50 versículos)
    const indice = diaDoAno % versiculosInspiradores.length;
    return versiculosInspiradores[indice];
};

const Palavra = () => {
    const [versiculo, setVersiculo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const carregarVersiculo = () => {
            // Verificar cache local (muda uma vez por dia)
            const hoje = new Date().toDateString();
            const cached = localStorage.getItem('versiculoDoDia');
            
            if (cached) {
                const { data, versiculo: versiculoCached } = JSON.parse(cached);
                if (data === hoje) {
                    setVersiculo(versiculoCached);
                    setLoading(false);
                    return;
                }
            }

            // Obter versículo do dia
            const versiculoHoje = obterVersiculoDoDia();
            
            // Salvar no cache
            localStorage.setItem('versiculoDoDia', JSON.stringify({ 
                data: hoje, 
                versiculo: versiculoHoje 
            }));
            
            setVersiculo(versiculoHoje);
            setLoading(false);
        };

        carregarVersiculo();
    }, []);

    return (
        <section id="espaco-da-palavra" className="palavra-section min-vh-100 d-flex flex-column justify-content-center align-items-center py-5">
            <div className="container">
                <div className="row align-items-center g-4">
                    {/* Esquerda: Título e Texto */}
                    <div className="col-md-6">
                        <InViewComponent delay={0.1}>
                            <div className="mb-4">
                                <Badge variant="success" size="md" className="mb-3">Palavra do Dia</Badge>
                                <h2 className="titulo-sobre mb-4">
                                    {loading ? 'Carregando...' : versiculo?.titulo}
                                </h2>
                            </div>
                        </InViewComponent>
                        
                        <InViewComponent delay={0.2}>
                            <Card className="palavra-card">
                                <Card.Body>
                                    {loading ? (
                                        <div className="text-center py-4">
                                            <div className="spinner-border text-success" role="status">
                                                <span className="visually-hidden">Carregando...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <blockquote className="mb-0 palavra-texto">
                                            {versiculo?.texto.split('\n\n').map((paragrafo, index) => (
                                                <p key={index} className={index === versiculo.texto.split('\n\n').length - 1 ? 'mb-0' : 'mb-3'}>
                                                    {paragrafo}
                                                </p>
                                            ))}
                                        </blockquote>
                                    )}
                                </Card.Body>
                            </Card>
                        </InViewComponent>
                    </div>
                    
                    {/* Direita: Imagem */}
                    <div className="col-md-6">
                        <InViewComponent delay={0.2}>
                            <Card hover={false} className="palavra-imagem-card">
                                <Card.Body className="p-0">
                                    <div className="palavra-imagem-wrapper">
                                        <img 
                                            src={palavraImg} 
                                            alt="Igreja Casa de Oração" 
                                            className="palavra-imagem"
                                        />
                                        <div className="palavra-imagem-overlay">
                                            <i className="bi bi-book"></i>
                                            <p>"Lâmpada para os meus pés é a tua palavra e luz para os meus caminhos."</p>
                                            <span>Salmos 119:105</span>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </InViewComponent>
                    </div>
                </div>
            </div>
        </section>
    );
};

const InViewComponent = ({ children, delay }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView({
        threshold: 0.3,
        triggerOnce: true
    });

    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
    }, [controls, inView]);

    return (
        <motion.div
            ref={ref}
            initial="hidden"
            animate={controls}
            transition={{ duration: 0.6, delay, ease: "easeInOut" }}
            variants={{
                hidden: { opacity: 0, y: 20 },
                visible: { opacity: 1, y: 0 }
            }}
        >
            {children}
        </motion.div>
    );
};

export default Palavra;
